module.exports = __webpack_public_path__ + "static/img/img-8.c6515e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-8.png
// module id = BK2i
// module chunks = 1